import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { withParentSize } from '@visx/responsive';
import { FDStack } from '@facet-wealth/design';
import {
  useTabContentContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';
import TableView from './TableView';

const styles = () => ({});

const AccountAllocationTabTemplatePicker = withParentSize(
  () => {
    const { activeTabResource } = useTabContentContext();

    if (activeTabResource.type() === 'FacetPlanAccountActionAllocationDetailBulkEditing') {
      return (
        <FDStack direction={'column'} spacing={2}>
          {activeTabResource.attr('tableSections').resources()
            .list()
            .map((tableSectionResource) => {
              return (
                <TableView
                  // height={parentHeight}
                  key={tableSectionResource.id()}
                  tableResourceOverride={tableSectionResource}
                  showColumnLabels
                  noIndividualCellSubmit
                />
              );
            })}
        </FDStack>
      );
    }

    return (
      <FDStack direction={'column'} spacing={2}>
        {activeTabResource.attr('tableSections').resources()
          .list()
          .map((tableSectionResource, i) => {
            return (
              <TableView
                // height={parentHeight}
                key={tableSectionResource.id()}
                tableResourceOverride={tableSectionResource}
                showColumnLabels={i === 0}
              />
            );
          })}
      </FDStack>
    );
  },
);

AccountAllocationTabTemplatePicker.defaultProps = {
  className: '',
};

AccountAllocationTabTemplatePicker.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccountAllocationTabTemplatePicker);
